import React, {useState} from 'react';
import SubBody from "../../../application/general/components/common/SubBody";
import {Button, Input, InputNumber, message, Select, Space, TimePicker} from "antd";
import {Option} from "antd/es/mentions";
import {t} from "i18next";
import DG_FormItem_LabelDetail from "../../../../../custom/data-entry/form/Item/LabelDetail";
import {downloadTool} from "../../../../../api/hrm/timekeeping/time-sheet/timesheet";

const General = props => {
    const onchangeCode = (value) => {
        if (value === "personnel code") {
            props.onChangeTimeKeeping(true)
        } else if (value === "time attendance code") {
            props.onChangeTimeKeeping(false)
        }
    }

    const handleCopyClick = () => {
        navigator.clipboard.writeText(props?.url).then(() => {
            message.success(t("timeKeeping-setting.timeKeeping-setting.time-keeping-gps.copy")).then(() => {
            });
        });

    };

    const[loadingDownload,setLoadingDownload] = useState(false)

    const handleDownloadTool = () => {
        setLoadingDownload(true)
        const isWindows = navigator.platform.includes('Win');
        const isLinux = navigator.platform.includes('Linux');

        downloadTool({system: isWindows ? "window" : isLinux ? "ubuntu" : "ubuntu"}).then((res) => {
            const url = window.URL.createObjectURL(new Blob([res]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', isWindows ? "Dogoo-Tool-Timekeeping.exe" : "Dogoo-App.deb"); //or any other extension
            document.body.appendChild(link);
            link.click();
        }).finally(() => setLoadingDownload(false))
    }

    return (
        <div className={'px-8 pt-3'}>
            <SubBody>
                {/*<DG_FormItem_LabelDetail*/}
                {/*    label={t("timeKeeping-setting.timeKeeping-setting.general-settings.time-attendance-code")}*/}
                {/*    labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.time-attendance-code-detail")}*/}
                {/*    name={"timekeepingCode"}*/}
                {/*>*/}
                {/*    <Select*/}
                {/*        allowClear*/}
                {/*        filterOption={(input, option) =>*/}
                {/*            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0*/}
                {/*        }*/}
                {/*        onChange={onchangeCode}*/}
                {/*    >*/}
                {/*        <Option*/}
                {/*            value="personnel code">{t("tnp.components.timekeeping.text21")}</Option>*/}
                {/*        <Option*/}
                {/*            value="time attendance code">{t("tnp.components.timekeeping.text22")}</Option>*/}
                {/*    </Select>*/}
                {/*</DG_FormItem_LabelDetail>*/}

                {/*{props.timeKeeping &&*/}
                {/*    <div>*/}

                {/*        <DG_FormItem_LabelDetail*/}
                {/*            label={t("timeKeeping-setting.timeKeeping-setting.general-settings.general-settings-auto.take-it")}*/}
                {/*            labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.general-settings-auto.take-it-detail")}*/}
                {/*            name={"lastpersonnelcode"}*/}
                {/*        >*/}
                {/*            <Input*/}
                {/*                placeholder={t("timeKeeping-setting.timeKeeping-setting.general-settings.general-settings-auto.take-it-form")}/>*/}
                {/*        </DG_FormItem_LabelDetail>*/}

                {/*    </div>*/}
                {/*}*/}

                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.general-settings.time-start-time-keeping")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.time-start-time-keeping-detail")}
                    name={"startmonthly"}
                >
                    <InputNumber
                        style={{width: "100%"}}
                        defaultValue={1}
                        min={1}
                        max={31}
                    />
                </DG_FormItem_LabelDetail>

                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.general-settings.exempted-from-closing")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.exempted-from-closing-detail")}
                    name={"time"}
                >
                    <TimePicker format={"HH:mm"} className={"width--100pc"} changeOnBlur={true}/>
                </DG_FormItem_LabelDetail>
                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.general-settings.show-on-timesheet")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.show-on-timesheet-detail")}
                    name={"showtimesheet"}
                >
                    <Select
                        allowClear
                        filterOption={(input, option) =>
                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                    >
                        <Option value="shift work">
                            {t("tnp.components.timekeeping.text23")}
                        </Option>
                        {/*<Option value="shift hours">*/}
                        {/*    {t("tnp.components.timekeeping.text24")}*/}
                        {/*</Option>*/}
                    </Select>
                </DG_FormItem_LabelDetail>
                <DG_FormItem_LabelDetail
                    label={t("timeKeeping-setting.timeKeeping-setting.general-settings.code-api-time-keeping")}
                    labelDetail={t("timeKeeping-setting.timeKeeping-setting.general-settings.code-api-time-keeping-detail")}
                    name={"codetimekeepingapi"}
                >
                    <Input onClick={handleCopyClick} disabled={true}/>
                </DG_FormItem_LabelDetail>
                {props?.url && <Space direction="vertical" className={"pl-4"}>
                    <span
                        className={'font-bold'}>{t("timeKeeping-setting.timeKeeping-setting.general-settings.time-keeping-url")}</span>
                    <span onClick={handleCopyClick}
                          className={"w-32 h-32 bg-cover bg-center bg-no-repeat transition-transform transform hover:scale-110 cursor-pointer"}
                          style={{color: "#1d9336"}}>{props?.url}</span>
                    <Button className={"mt-5"} type="primary"
                            loading={loadingDownload}
                            onClick={handleDownloadTool}>{t("timeKeeping-setting.timeKeeping-setting.general-settings.time-keeping-url-title")}</Button>
                </Space>}
            </SubBody>
        </div>
    );
};

General.propTypes = {};

export default General;

